const decoded = Buffer.from(
  global.window.LX.config,
  'base64'
).toString('ascii')

const config = JSON.parse(decoded)

export default config
